
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 53 53"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('g',{attrs:{"id":"Ebene_1-2","data-name":"Ebene 1"}},[_c('g',{attrs:{"id":"Ellipse_2","data-name":"Ellipse 2"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"18.68","cy":"27.29","r":"1.82"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"18.68","cy":"27.29","r":"1.79"}})]),_c('path',{staticClass:"cls-3",attrs:{"d":"M16.83 33.78H20a4.48 4.48 0 014.48 4.48v5.51a2 2 0 01-2 2h-8a2 2 0 01-2-2v-5.66a4.33 4.33 0 014.35-4.33z"}}),_c('g',{attrs:{"id":"Ellipse_2-2","data-name":"Ellipse 2"}},[_c('circle',{staticClass:"cls-1",attrs:{"cx":"34.68","cy":"27.29","r":"1.82"}}),_c('circle',{staticClass:"cls-2",attrs:{"cx":"34.68","cy":"27.29","r":"1.79"}})]),_c('path',{staticClass:"cls-3",attrs:{"d":"M32.83 33.78H36a4.48 4.48 0 014.48 4.48v5.51a2 2 0 01-2 2h-8a2 2 0 01-2-2v-5.66a4.33 4.33 0 014.35-4.33z"}}),_c('text',{attrs:{"transform":"translate(22.38 27.28)","font-size":"23.97","stroke-width":".75","font-family":"MyriadPro-Regular,Myriad Pro","stroke-miterlimit":"10"}},[_v('?')])])])])
          )
        }
      }
    